import React, { useState, useEffect, useContext, useRef } from "react";
import "./Repairs.css";
import InputField from "../../Transactions/SalesForm/InputfieldSales";
import { Container, Row, Col, Button, Form, Dropdown, Table } from "react-bootstrap";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import baseURL from "../../../../Url/NodeBaseURL";
import axios from "axios";
import { AiOutlinePlus } from "react-icons/ai";
import { AuthContext } from "../../../Pages/Login/Context";
import { FaTrash, FaEdit } from "react-icons/fa";
import Webcam from "react-webcam";
import { v4 as uuidv4 } from 'uuid';
import { counter } from "@fortawesome/fontawesome-svg-core";

const RepairForm = () => {
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];
  const defaultDeliveryDate = new Date();
  defaultDeliveryDate.setDate(today.getDate() + 3);

  const formattedDate = defaultDeliveryDate.toISOString().split("T")[0];
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { authToken, userId, userName } = useContext(AuthContext);

  const { state } = useLocation();
  const { mobile } = location.state || {};
  const initialSearchValue = location.state?.mobile || '';

  // Get tab ID for localStorage
  const getTabId = () => {
    const urlParams = new URLSearchParams(window.location.search);
    let tabId = urlParams.get('tabId');
    if (!tabId) {
      tabId = sessionStorage.getItem('tabId');
    }
    if (!tabId) {
      tabId = uuidv4();
      sessionStorage.setItem('tabId', tabId);
      const newUrl = `${window.location.pathname}?tabId=${tabId}`;
      window.history.replaceState({}, '', newUrl);
    }
    return tabId;
  };

  const tabId = getTabId();



  // Main form data
  const [formData, setFormData] = useState({
    customer_id: "",
    account_name: "",
    mobile: "",
    email: "",
    address1: "",
    address2: "",
    address3: "",
    city: "",
    staff: userName,
    delivery_date: formattedDate,
    place: "",
    metal: "",
    counter: "",
    entry_type: "Repair",
    receipt_no: "",
    repair_no: "",
    date: formattedToday,
    metal_type: "",
    item: "",
    tag_no: "",
    description: "",
    purity: "",
    category: "",
    sub_category: "",
    gross_weight: "",
    pcs: "",
    estimated_dust: "",
    estimated_amt: "",
    extra_weight: "",
    stone_value: "",
    making_charge: "",
    handling_charge: "",
    total: "",
    taxable_amt: "",
    total_amt: "",
    status: "Pending",
    repair_id: ""
  });

  // Repair items data (for temporary table - stored in localStorage)
  const [repairItems, setRepairItems] = useState(() => {
    const savedData = localStorage.getItem(`repairItems_${tabId}`);
    return savedData ? JSON.parse(savedData) : [];
  });

  const [editIndex, setEditIndex] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [metalTypes, setMetalTypes] = useState([]);
  const [purityData, setPurityData] = useState([]);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filteredPurity, setFilteredPurity] = useState([]);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const webcamRef = useRef(null);
  const fileInputRef = useRef(null);

  // Save repair items to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem(`repairItems_${tabId}`, JSON.stringify(repairItems));
  }, [repairItems, tabId]);

  // Add this useEffect to fetch complete customer details when customer_id is available
  useEffect(() => {
    const fetchCompleteCustomerDetails = async () => {
      if (formData.customer_id) {
        try {
          const customer = customers.find(cust => String(cust.account_id) === String(formData.customer_id));
          if (customer) {
            setFormData(prev => ({
              ...prev,
              customer_id: customer.account_id,
              account_name: customer.account_name,
              mobile: customer.mobile || "",
              email: customer.email || "",
              address1: customer.address1 || "",
              address2: customer.address2 || "",
              city: customer.city || "",
              pincode: customer.pincode || "",
              state: customer.state || "",
              state_code: customer.state_code || "",
              aadhar_card: customer.aadhar_card || "",
              gst_in: customer.gst_in || "",
              pan_card: customer.pan_card || "",
            }));
          }
        } catch (error) {
          console.error('Error fetching customer details:', error);
        }
      }
    };

    fetchCompleteCustomerDetails();
  }, [formData.customer_id, customers]);

  // Update the useEffect that handles location state to set customer_id instead of individual fields
  useEffect(() => {
    if (location.state?.customerData) {
      // Only set the customer_id, the above useEffect will handle the rest
      setFormData(prev => ({
        ...prev,
        customer_id: location.state.customerData.customer_id
      }));
    }

    // Set repair_no from navigation state if available
    if (location.state?.repair_no) {
      setFormData(prev => ({
        ...prev,
        repair_no: location.state.repair_no
      }));
    }
  }, [location.state]);

  // Fetch customers
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${baseURL}/get/account-details`);
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const result = await response.json();

        const customers = result.filter(
          (item) => item.account_group === 'CUSTOMERS'
        );

        setCustomers(customers);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Fetch Purity Data
  useEffect(() => {
    const fetchPurity = async () => {
      try {
        const response = await axios.get(`${baseURL}/purity`);
        setPurityData(response.data);
      } catch (error) {
        console.error("Error fetching purity data:", error);
      }
    };

    fetchPurity();
  }, []);

  // Filter Purity Data based on selected Metal Type
  useEffect(() => {
    if (formData.metal_type) {
      const filtered = purityData.filter(
        (item) => item.metal === formData.metal_type
      );
      setFilteredPurity(filtered);
    } else {
      setFilteredPurity([]);
    }
  }, [formData.metal_type, purityData]);

  // Fetch Metal Types
  useEffect(() => {
    const fetchMetalTypes = async () => {
      try {
        const response = await axios.get(`${baseURL}/metaltype`);
        setMetalTypes(response.data);
      } catch (error) {
        console.error("Error fetching metal types:", error);
      }
    };
    fetchMetalTypes();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleCustomerChange = (customerId) => {
    setFormData((prevData) => ({
      ...prevData,
      customer_id: customerId,
    }));

    const customer = customers.find((cust) => String(cust.account_id) === String(customerId));

    if (customer) {
      setFormData(prev => ({
        ...prev,
        customer_id: customer.account_id,
        account_name: customer.account_name,
        mobile: customer.mobile || "",
        email: customer.email || "",
        address1: customer.address1 || "",
        address2: customer.address2 || "",
        city: customer.city || "",
        pincode: customer.pincode || "",
        state: customer.state || "",
        state_code: customer.state_code || "",
        aadhar_card: customer.aadhar_card || "",
        gst_in: customer.gst_in || "",
        pan_card: customer.pan_card || "",
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        customer_id: "",
        account_name: "",
        mobile: "",
        email: "",
        address1: "",
        address2: "",
        city: "",
        pincode: "",
        state: "",
        state_code: "",
        aadhar_card: "",
        gst_in: "",
        pan_card: "",
      }));
    }
  };

  // Handle mobile number from navigation
  useEffect(() => {
    if (mobile) {
      console.log("Selected Mobile from New Link:", mobile);

      const matchedCustomer = customers.find((cust) => cust.mobile === mobile);

      if (matchedCustomer) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          customer_id: matchedCustomer.account_id,
          account_name: matchedCustomer.account_name,
          mobile: matchedCustomer.mobile,
          email: matchedCustomer.email || "",
          address1: matchedCustomer.address1 || "",
          address2: matchedCustomer.address2 || "",
          city: matchedCustomer.city || "",
          pincode: matchedCustomer.pincode || "",
          state: matchedCustomer.state || "",
          state_code: matchedCustomer.state_code || "",
          aadhar_card: matchedCustomer.aadhar_card || "",
          gst_in: matchedCustomer.gst_in || "",
          pan_card: matchedCustomer.pan_card || "",
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          mobile: mobile,
        }));
      }
    }
  }, [mobile, customers]);

  // Image handling functions
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
    setIsCameraOpen(false);
  };

  const clearImage = () => {
    setImage(null);
  };

  // Date parsing for edit
  const parseDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Fetch repair data for editing
  useEffect(() => {
    const fetchRepairById = async () => {
      if (id) {
        try {
          const response = await axios.get(`${baseURL}/get/repairs/${id}`);
          const fetchedData = response.data;
          console.log("Fetched Data:", fetchedData);

          if (fetchedData.image) {
            setImage(fetchedData.image);
          }

          const formattedData = {
            ...fetchedData,
            date: parseDate(fetchedData.date),
            delivery_date: parseDate(fetchedData.delivery_date),
          };

          setFormData((prevData) => ({
            ...prevData,
            ...formattedData,
          }));

        } catch (error) {
          console.error("Error fetching repair data:", error);
          alert("Failed to load repair details. Please try again later.");
        }
      }
    };

    fetchRepairById();
  }, [id]);

  // Navigation functions
  const handleClose = () => {
    navigate(-1);
  };

  const handleBack = () => {
    navigate(-1);
  };

  // Add Customer function
  const handleAddCustomer = (mobile) => {
    console.log("handleAddCustomer received mobile:", mobile);
    navigate("/customermaster", {
      state: {
        from: `/repairs`,
        mobile: mobile
      }
    });
  };

  // Fetch last RPN number for new repairs
  useEffect(() => {
    if (!id) {
      const fetchLastRPNNumber = async () => {
        try {
          const response = await axios.get(`${baseURL}/lastRPNNumber`);
          setFormData((prev) => ({
            ...prev,
            repair_no: location.state?.repair_no || response.data.lastRPNNumber,
          }));
        } catch (error) {
          console.error('Error fetching RPN number:', error);
        }
      };

      fetchLastRPNNumber();
    }
  }, [id, location.state]);

  // Calculate total for each item (estimated_amt + making_charge)
  const calculateItemTotal = (item) => {
    const estimatedAmt = parseFloat(item.estimated_amt) || 0;
    const makingCharge = parseFloat(item.making_charge) || 0;
    return (estimatedAmt + makingCharge).toFixed(2);
  };

  // Calculate summary totals
  const calculateSummary = () => {
    let totalAmount = 0;
    let taxableAmount = 0;
    let taxAmount = 0;
    let netAmount = 0;

    repairItems.forEach(item => {
      const itemTotal = parseFloat(calculateItemTotal(item)) || 0;
      totalAmount += itemTotal;
    });

    // For repairs, assuming no tax for now - you can modify this logic as needed
    taxableAmount = totalAmount;
    taxAmount = 0;
    netAmount = totalAmount;

    return {
      totalAmount: totalAmount.toFixed(2),
      taxableAmount: taxableAmount.toFixed(2),
      taxAmount: taxAmount.toFixed(2),
      netAmount: netAmount.toFixed(2)
    };
  };

  // Repair Items Management Functions
  const handleAddItem = () => {
    // Validate required fields
    if (!formData.category || !formData.gross_weight || !formData.estimated_amt) {
      alert("Please fill in Particulars, Gross or Net Wt, and amount.");
      return;
    }

    const newItem = {
      customer_id: formData.customer_id,
      account_name: formData.account_name,
      mobile: formData.mobile,
      email: formData.email || "",
      address1: formData.address1 || "",
      address2: formData.address2 || "",
      city: formData.city || "",
      pincode: formData.pincode || "",
      state: formData.state || "",
      state_code: formData.state_code || "",
      aadhar_card: formData.aadhar_card || "",
      gst_in: formData.gst_in || "",
      pan_card: formData.pan_card || "",
      entry_type: formData.entry_type,
      repair_no: formData.repair_no,
      date: formData.date,
      staff: formData.staff,
      delivery_date: formData.delivery_date,
      counter: formData.counter,
      category: formData.category,
      item: formData.item,
      sub_category: formData.sub_category,
      metal_type: formData.metal_type,
      description: formData.description,
      purity: formData.purity,
      gross_weight: formData.gross_weight || "0",
      pcs: formData.pcs || "1",
      estimated_dust: formData.estimated_dust || "0",
      estimated_amt: formData.estimated_amt || "0",
      extra_weight: formData.extra_weight || "0",
      stone_value: formData.stone_value || "0",
      making_charge: formData.making_charge || "0",
      handling_charge: formData.handling_charge || "0",
      total: calculateItemTotal(formData), // Calculate total automatically
      tag_no: formData.tag_no || "",
      repair_id: formData.repair_id || "",
    };

    if (editIndex !== null) {
      // Update existing item
      const updatedItems = [...repairItems];
      updatedItems[editIndex] = newItem;
      setRepairItems(updatedItems);
      setEditIndex(null);
    } else {
      // Add new item
      setRepairItems([...repairItems, newItem]);
    }

    // Reset item form fields
    setFormData(prev => ({
      ...prev,
      category: "",
      item: "",
      sub_category: "",
      metal_type: "",
      description: "",
      purity: "",
      gross_weight: "",
      pcs: "",
      estimated_dust: "",
      estimated_amt: "",
      extra_weight: "",
      stone_value: "",
      making_charge: "",
      handling_charge: "",
      total: "",
      tag_no: "",
    }));
  };

  const handleEditItem = (index) => {
    const item = repairItems[index];
    setFormData(prev => ({
      ...prev,
      customer_id: formData.customer_id,
      account_name: formData.account_name,
      mobile: formData.mobile,
      email: formData.email || "",
      address1: formData.address1 || "",
      address2: formData.address2 || "",
      city: formData.city || "",
      pincode: formData.pincode || "",
      state: formData.state || "",
      state_code: formData.state_code || "",
      aadhar_card: formData.aadhar_card || "",
      gst_in: formData.gst_in || "",
      pan_card: formData.pan_card || "",
      entry_type: item.entry_type,
      repair_no: item.repair_no,
      date: item.date,
      staff: item.staff,
      delivery_date: item.delivery_date,
      counter: item.counter,
      repair_id: item.repair_id,
      category: item.category,
      item: item.item,
      sub_category: item.sub_category,
      metal_type: item.metal_type,
      description: item.description,
      purity: item.purity,
      gross_weight: item.gross_weight,
      pcs: item.pcs,
      estimated_dust: item.estimated_dust,
      estimated_amt: item.estimated_amt,
      extra_weight: item.extra_weight,
      stone_value: item.stone_value,
      making_charge: item.making_charge,
      handling_charge: item.handling_charge,
      total: item.total,
      tag_no: item.tag_no,
    }));
    setEditIndex(index);
  };

  const handleDeleteItem = (index) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      const updatedItems = repairItems.filter((_, i) => i !== index);
      setRepairItems(updatedItems);
    }
  };

  const clearAllItems = () => {
    if (window.confirm('Are you sure you want to clear all items?')) {
      setRepairItems([]);
    }
  };

  // Calculate total for all items
  const calculateTotal = () => {
    return repairItems.reduce((sum, item) => {
      return sum + (parseFloat(item.total) || 0);
    }, 0);
  };

  // Main form submission - Save ONE repair at a time
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.mobile && !formData.account_name) {
      alert("Please select either mobile number or customer name before saving.");
      return;
    }

    if (repairItems.length === 0) {
      alert("Please add at least one repair item before saving.");
      return;
    }

    try {
      const summary = calculateSummary();
      const taxableAmt = summary.taxableAmount;

      const savedRepairs = [];

      // ✅ Always POST — no update logic now
      for (const item of repairItems) {
        const repairData = {
          ...formData,
          ...item,
          image,
          total: item.total || "0",
          taxable_amt: taxableAmt,
          total_amt: item.total,
        };

        const response = await axios.post(`${baseURL}/add/repairs`, repairData);

        if (response.status === 201 || response.status === 200) {
          savedRepairs.push(response.data);
        }
      }

      if (savedRepairs.length > 0) {
        alert(`Successfully saved ${savedRepairs.length} repair item(s)!`);
        console.log(`Successfully saved ${savedRepairs.length} repair item(s)!`)

        localStorage.removeItem(`repairItems_${tabId}`);

        navigate("/repairstable");
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      alert("Failed to submit the repair entry");
    }
  };


  const summary = calculateSummary();

  return (
    <div className="main-container">
      <Container className="repair-form-container">
        <Form onSubmit={handleSubmit}>
          <div className="repair-form">
            {/* Left Section */}
            <div className="repair-form-left">
              <Col className="form-section">
                <h4 className="mb-4">Customer Details</h4>
                <Row>
                  <Col xs={12} md={3} className="d-flex align-items-center">
                    <div style={{ flex: 1 }}>
                      <InputField
                        label="Mobile"
                        name="mobile"
                        type="select"
                        value={formData.mobile || ""}
                        onChange={(e) => {
                          const inputMobile = e.target.value;
                          if (!inputMobile) {
                            setFormData((prev) => ({
                              ...prev,
                              mobile: "",
                              account_name: "",
                              email: "",
                              address1: "",
                              address2: "",
                              city: "",
                              pincode: "",
                              state: "",
                              aadhar_card: "",
                              gst_in: "",
                            }));
                            return;
                          }

                          const isValidMobile = /^\d{10}$/.test(inputMobile);
                          if (!isValidMobile) {
                            alert("Please enter a valid 10-digit mobile number.");
                            return;
                          }

                          setFormData((prev) => ({ ...prev, mobile: inputMobile }));

                          const existing = customers.find((c) => c.mobile === inputMobile);
                          if (existing) {
                            handleCustomerChange(existing.account_id);
                          }
                        }}
                        onKeyDown={({ key, value }) => {
                          if (key === "Enter") {
                            const isValidMobile = /^\d{10}$/.test(value);
                            const exists = customers.some((c) => c.mobile === value);
                            if (isValidMobile && !exists) {
                              handleAddCustomer(value);
                            }
                          }
                        }}
                        options={customers.map((c) => ({ value: c.mobile, label: c.mobile }))}
                        allowCustomInput
                      />
                    </div>
                    <AiOutlinePlus
                      size={20}
                      color="black"
                      onClick={() => handleAddCustomer(formData.mobile)}
                      style={{
                        marginLeft: "10px",
                        cursor: "pointer",
                        marginBottom: "20px",
                      }}
                    />
                  </Col>

                  <Col xs={12} md={3}>
                    <InputField
                      label="Customer Name"
                      name="account_name"
                      type="select"
                      value={formData.account_name.toUpperCase() || ""}
                      onChange={(e) => {
                        const inputName = (e.target.value || "").toUpperCase();

                        if (!inputName) {
                          setFormData((prev) => ({
                            ...prev,
                            mobile: "",
                            account_name: "",
                            email: "",
                            address1: "",
                            address2: "",
                            city: "",
                            pincode: "",
                            state: "",
                            aadhar_card: "",
                            gst_in: "",
                          }));
                          return;
                        }

                        setFormData((prev) => ({ ...prev, account_name: inputName }));

                        const existing = customers.find((c) => c.account_name.toUpperCase() === inputName);
                        if (existing) {
                          handleCustomerChange(existing.account_id);
                        }
                      }}
                      options={customers.map((c) => ({
                        value: c.account_name.toUpperCase(),
                        label: c.account_name.toUpperCase(),
                      }))}
                      allowCustomInput
                    />
                  </Col>
                  <Col xs={12} md={3}>
                    <InputField
                      label="Email:"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      readOnly
                    />
                  </Col>
                  <Col xs={12} md={3}>
                    <InputField
                      label="Address1:"
                      name="address1"
                      value={formData.address1}
                      onChange={handleChange}
                      readOnly
                    />
                  </Col>
                  <Col xs={12} md={3}>
                    <InputField
                      label="Address2:"
                      name="address2"
                      value={formData.address2}
                      onChange={handleChange}
                      readOnly
                    />
                  </Col>
                  <Col xs={12} md={3}>
                    <InputField
                      label="City:"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      readOnly
                    />
                  </Col>
                </Row>
              </Col>
            </div>
            <div className="repair-form-right">
              <Col className="form-section">
                <Row>
                  <InputField
                    label="Entry Type:"
                    name="entry_type"
                    type="select"
                    value={formData.entry_type}
                    onChange={handleChange}
                    options={[
                      { value: "Repair", label: "Repair" },
                      { value: "Poolish", label: "Poolish" },
                      { value: "Other", label: "Other" }
                    ]}
                  />
                </Row>
                <Row>
                  <InputField
                    label="Repair No:"
                    name="repair_no"
                    value={formData.repair_no}
                    onChange={handleChange}
                    readOnly
                  />
                </Row>
                <Row>
                  <InputField label="Date:" name="date" type="date" value={formData.date} onChange={handleChange} />
                </Row>
              </Col>
            </div>
          </div>

          <Row className="form-section pt-4">
            <Col xs={12} md={2}>
              <InputField label="Staff:" name="staff" value={formData.staff} onChange={handleChange} readOnly />
            </Col>
            <Col xs={12} md={2}>
              <InputField label="Delivery Date:" type="date" name="delivery_date" value={formData.delivery_date} onChange={handleChange} />
            </Col>
            <Col xs={12} md={3}>
              <InputField label="Counter:" name="counter" value={formData.counter} onChange={handleChange} />
            </Col>
          </Row>
          <Col className="form-section">
            <h4>Repair Item Details</h4>
            <Row>
              <Col xs={12} md={3}>
                <InputField label="Particulars" name="category" value={formData.category} onChange={handleChange} />
              </Col>
              <Col xs={12} md={2}>
                <InputField label="Gross Wt / Net Wt" name="gross_weight" value={formData.gross_weight} onChange={handleChange} />
              </Col>
              <Col xs={12} md={2}>
                <InputField label="Amount" name="estimated_amt" value={formData.estimated_amt} onChange={handleChange} />
              </Col>
              <Col xs={12} md={2}>
                <div className="image-upload-container">

                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic-button">Upload Image</Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => fileInputRef.current.click()}>
                        Select Image
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => setIsCameraOpen(true)}>
                        Capture Image
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                  />

                  {isCameraOpen && (
                    <div className="webcam-container mt-2">
                      <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        className="img-thumbnail"
                      />
                      <div className="d-flex gap-2 mt-2">
                        <Button onClick={captureImage} variant="primary">
                          Capture
                        </Button>
                        <Button onClick={() => setIsCameraOpen(false)} variant="danger">
                          Cancel
                        </Button>
                      </div>
                    </div>
                  )}

                  {image && (
                    <div style={{ position: "relative", display: "inline-block", marginTop: "10px" }}>
                      <img src={image} alt="Selected"
                        style={{
                          width: "100px",
                          height: "100px",
                          borderRadius: "8px",
                        }} />
                      <button
                        type="button"
                        onClick={clearImage}
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          background: "transparent",
                          border: "none",
                          color: "red",
                          fontSize: "16px",
                          cursor: "pointer",
                          zIndex: 10,
                        }}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  )}
                </div>
              </Col>
              <Col xs={12} md={2}>
                <Button
                  style={{ backgroundColor: "#a36e29", borderColor: "#a36e29" }}
                  onClick={handleAddItem}
                  className="me-2 custom-repair-btn"
                >
                  {editIndex !== null ? "Update Item" : "Add Item"}
                </Button>
                {editIndex !== null && (
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setEditIndex(null);
                      setFormData(prev => ({
                        ...prev,
                        category: "",
                        item: "",
                        sub_category: "",
                        metal_type: "",
                        description: "",
                        purity: "",
                        gross_weight: "",
                        pcs: "",
                        estimated_dust: "",
                        estimated_amt: "",
                        extra_weight: "",
                        stone_value: "",
                        making_charge: "",
                        handling_charge: "",
                        total: "",
                        tag_no: "",
                      }));
                    }}
                  >
                    Cancel Edit
                  </Button>
                )}
              </Col>
            </Row>
          </Col>
          {repairItems.length > 0 && (
            <div className="form-section">
              <h4>Repair Items ({repairItems.length})</h4>
              <div className="table-responsive">
                <Table striped bordered hover>
                  <thead style={{ fontSize: "13px" }}>
                    <tr>
                      <th>S No</th>
                      <th>Particulars</th>
                      <th>Gross / Net Wt</th>
                      <th>Amount</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "13px" }}>
                    {repairItems.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.category}</td>
                        <td>{item.gross_weight}</td>
                        <td>{item.estimated_amt}</td>
                        <td>
                          <FaEdit
                            style={{ cursor: "pointer", marginLeft: "10px", color: "blue" }}
                            onClick={() => handleEditItem(index)}
                          />
                          <FaTrash
                            style={{ cursor: "pointer", marginLeft: "10px", color: "red" }}
                            onClick={() => handleDeleteItem(index)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="3" className="text-end"><strong>Grand Total:</strong></td>
                      <td colSpan="1"><strong>{calculateTotal().toFixed(2)}</strong></td>
                      <td>
                        <Button variant="outline-danger" size="sm" onClick={clearAllItems}>
                          Clear All
                        </Button>
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </div>

              {/* Summary Section */}
              <div>
                <h4 className="mb-3" style={{ fontSize: "20px" }}>Summary</h4>
                <Table bordered hover responsive style={{ fontSize: "13px" }}>
                  <tbody>
                    <tr>
                      <td colSpan="20" className="text-right">
                        <strong>Total Amount</strong>
                      </td>
                      <td colSpan="4">{summary.totalAmount}</td>
                    </tr>
                    <tr>
                      <td colSpan="20" className="text-right">
                        <strong>Taxable Amount</strong>
                      </td>
                      <td colSpan="4">{summary.taxableAmount}</td>
                    </tr>
                    <tr>
                      <td colSpan="20" className="text-right">
                        <strong>Tax Amount</strong>
                      </td>
                      <td colSpan="4">{summary.taxAmount}</td>
                    </tr>
                    <tr>
                      <td colSpan="20" className="text-right">
                        <strong>Net Amount</strong>
                      </td>
                      <td colSpan="4">{summary.netAmount}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          )}

          <div className="form-buttons">
            <Button onClick={handleClose} className="cus-back-btn">
              Close
            </Button>
            <Button className="cus-back-btn" onClick={handleBack}>Cancel</Button>
            <Button
              type="submit"
              // variant="primary"
              style={{ backgroundColor: "#a36e29", borderColor: "#a36e29" }}
              className="cus-submit-btn"
              disabled={repairItems.length === 0}
            >
              {id ? "Update" : "Save"}
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  );
};

export default RepairForm;